import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import practicalSkillsEsPNG from '~/assets/images/history/history-practical-skills-es.png'
import practicalSkillsEsWEBP from '~/assets/images/history/history-practical-skills-es.webp'
import practicalSkillsPtPNG from '~/assets/images/history/history-practical-skills-pt.png'
import practicalSkillsPtWEBP from '~/assets/images/history/history-practical-skills-pt.webp'
import practicalSkillsPNG from '~/assets/images/history/history-practical-skills.png'
import practicalSkillsWEBP from '~/assets/images/history/history-practical-skills.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { selectLanguage } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const LOCALE_IMAGE_MAP: Record<string, { png: string; webp: string }> = {
  es: { png: practicalSkillsEsPNG, webp: practicalSkillsEsWEBP },
  pt: { png: practicalSkillsPtPNG, webp: practicalSkillsPtWEBP },
  en: { png: practicalSkillsPNG, webp: practicalSkillsWEBP },
}

const PracticalSkills = ({ nextPagePath, pageId }: TPageProps) => {
  const lang = useSelector(selectLanguage)
  const { png, webp } = LOCALE_IMAGE_MAP[lang] ?? LOCALE_IMAGE_MAP.en

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Develop practical skills',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={webp} type="image/webp" />
            <img src={png} alt="Develop practical skills" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans
            ns="history"
            i18nKey="onboarding.historyPracticalSkills.title"
          />
        </S.Title>

        <S.Subtitle>
          <Trans
            ns="history"
            i18nKey="onboarding.historyPracticalSkills.subtitle"
          />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default PracticalSkills
